// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Row from '../../../../common/atoms/Row';
import Col from '../../../../common/atoms/Col';
import MyAccountLeftNav from './MyAccountLeftNav.view';
import withStyles from '../../../../common/hoc/withStyles';
import styles from '../styles/MyAccountContainer.style';
import AccountHeader from '../../common/organism/AccountHeader';
import AccountDrawerBottomLinksNew from '../../AccountDrawer/molecules/AccountDrawerBottomLinksNew';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import AccountLabels, { GLOBAL_LABELS } from './Account.labels';

/**
 * @function MyAccountLayoutView The AccountLayout component will provide a list of left
 * navigationLinks and the component associated with it
 * The main component will include this Layout and pass the component to render on the right panel
 * @param {navData} navData The list of links in the left nav as config object
 * @param {mainContent} mainContent The component to be rendered on the right side
 */

const DEFAULT_ACTIVE_COMPONENT = 'account-overview';
const ACCOUNT_OVERVIEW_PATHS = ['/us/account', '/ca/account'];
const PLACE_PERKS_DASHBOARD_PATHS = ['/us/account/place-perks', '/ca/account/place-perks'];
const ORDERS_PATHS = ['/us/account/orders', '/ca/account/orders'];

const getIsPlacePerksDashboardPath = (router) => {
  return PLACE_PERKS_DASHBOARD_PATHS.includes(router?.asPath);
};
const getIsOrderDashboardPath = (router) => {
  return ORDERS_PATHS.includes(router?.asPath);
};

const getPlacePerksDashboardOutline = (isPlacePerkEnabled, isPlacePerksDashboardPath) => {
  return isPlacePerkEnabled && isPlacePerksDashboardPath ? 'place-perks-dashboard-outline' : '';
};

const getShowAccountHeaderClass = (isPlacePerkEnabled, isAccountOverviewPath) => {
  return isPlacePerkEnabled && isAccountOverviewPath ? 'show-account-header-in-mobile' : '';
};

const MyAccountLayoutView = (props) => {
  const {
    navData,
    mainContent: MainContent,
    active,
    activeSubComponent,
    className,
    router,
    isUserLoggedIn,
    pageContentRef,
    isBIAEnabled,
    isRAREnabled,
    isPlacePerkEnabled,
    isGuestFav,
  } = props;
  const globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, AccountLabels);

  const isAccountOverviewPath = ACCOUNT_OVERVIEW_PATHS.includes(router?.asPath);
  const isPlacePerksDashboardPath = getIsPlacePerksDashboardPath(router);
  const isOrdersPath = getIsOrderDashboardPath(router);
  const bgColor =
    !isAccountOverviewPath && !isPlacePerksDashboardPath && !isOrdersPath ? 'bg-white' : '';
  const dashboardOutline = isAccountOverviewPath ? 'account-dashboard-outline' : '';
  const placePerksDashboardOutline = getPlacePerksDashboardOutline(
    isPlacePerkEnabled,
    isPlacePerksDashboardPath
  );
  const showAccountHeaderInMobileClass = getShowAccountHeaderClass(
    isPlacePerkEnabled,
    isAccountOverviewPath
  );
  const ComponentBottonLink =
    activeSubComponent === DEFAULT_ACTIVE_COMPONENT
      ? { componentBottonLink: AccountDrawerBottomLinksNew }
      : {};
  useEffect(() => {
    return () => {
      window.localStorage.removeItem('ORDER_FILTER');
    };
  }, []);
  return (
    <div className={className}>
      {isUserLoggedIn || isGuestFav ? (
        <Row fullBleed={true}>
          <Col
            colSize={{ large: 3, medium: 8, small: 6 }}
            className={`is-visible-nav ${showAccountHeaderInMobileClass}`}
          >
            {isGuestFav ? (
              <Col
                colSize={{
                  small: 0,
                  medium: 0,
                  large: 2,
                }}
                isNotInlineBlock
                className="hide-on-mobile hide-on-tablet"
              >
                <BodyCopy
                  fontSize="fs20"
                  className="user-welcome is-guest-fav"
                  fontWeight="extrabold"
                  fontFamily="secondary"
                  textAlign="right"
                  component="h1"
                >
                  {`${renderLabel(
                    globalLabels?.header?.lbl_header_helloText,
                    'lbl_header_helloText'
                  )?.replace(',', '')}`}
                </BodyCopy>
              </Col>
            ) : (
              <AccountHeader />
            )}
            <MyAccountLeftNav
              navData={navData}
              active={active}
              activeSubComponent={activeSubComponent}
              isBIAEnabled={isBIAEnabled}
              isRAREnabled={isRAREnabled}
              isPlacePerkEnabled={isPlacePerkEnabled}
              isGuestFav={isGuestFav}
            />
          </Col>

          <Col
            colSize={{ large: 9, medium: 8, small: 6 }}
            role="main"
            className={`account-main ${bgColor}`}
          >
            <div
              ref={pageContentRef}
              tabIndex={-1}
              className={`no-outline ${dashboardOutline} ${placePerksDashboardOutline}`}
            >
              <MainContent
                fromPage="Account"
                router={router}
                isUserLoggedIn={isUserLoggedIn}
                isGuestFav={isGuestFav}
                {...ComponentBottonLink}
              />
            </div>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col colSize={{ large: 12, medium: 8, small: 6 }} role="main">
            <div ref={pageContentRef} tabIndex={-1} className="no-outline">
              <MainContent router={router} isUserLoggedIn={isUserLoggedIn} />
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

MyAccountLayoutView.propTypes = {
  navData: PropTypes.shape([]),
  mainContent: PropTypes.func,
  active: PropTypes.string,
  activeSubComponent: PropTypes.string,
  className: PropTypes.string,
  router: PropTypes.shape({}),
  isUserLoggedIn: PropTypes.bool.isRequired,
  pageContentRef: PropTypes.func,
  isGuestFav: PropTypes.bool,
};

MyAccountLayoutView.defaultProps = {
  navData: [],
  mainContent: () => {},
  active: '',
  activeSubComponent: '',
  className: '',
  router: {},
  pageContentRef: () => {},
  isGuestFav: false,
};

export default withStyles(MyAccountLayoutView, styles);
export { MyAccountLayoutView as MyAccountLayoutViewVanilla };
